import { useRouter } from '@tribeplatform/react-sdk'
import {
  IconButton,
  type IconButtonProps,
} from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export interface SidebarBackButtonProps {
  href?: string
  onClick?: IconButtonProps['onClick']
}

export const SidebarBackButton = ({
  href,
  onClick,
}: SidebarBackButtonProps) => {
  const { Link } = useRouter()

  return (
    <IconButton
      variant="secondaryNeutral"
      rounded
      as={Link}
      href={href}
      onClick={onClick}
      icon={<SvgIcon className="rtl:-scale-x-100" name="arrow-left" />}
    />
  )
}
